/**
 * 部标机设备报警相关请求
 */
import request from '@/utils/request';

export interface JtDeviceAlarmListRequestParams {
  page: number;
  limit: number;
  start?: string;
  end?: string;
  carIds?: Array<number>;
  alarmTypes?: Array<string>;
  plateNumber?: string;
}

export const jtDeviceAlarmListRequestPath = '/api/v2/jt808Device/video/list';
// 获取部标机设备报警数据
export const jtDeviceAlarmListRequest = (
  data: JtDeviceAlarmListRequestParams
) => {
  return request.post(jtDeviceAlarmListRequestPath, data);
};

// 获取部标机设备报警视频URL
export const jtDeviceAlarmVideoRequest = (fileName: string, group?: string) => {
  let g = group ? `/${group}` : ''
  return request.get(`/api/v2/jt808Device/video/${fileName}${g}`);
};
// 获取部标机设备报警视频URL——V2
export const jtDeviceAlarmVideoRequestV2 = (fileName: string, group?: string, bucket?: number | string) => {
  let g = group ? `/${group}` : '';
  let b = (!!bucket || bucket === 0) ? `/${bucket}` : ``;
  return request.get(`/api/v2/jt808Device/video/${fileName}${g}${b}`);
};



//文件解冻
export const jtDeviceAlarmVideoUnfreezeRequest = (params: OssEntity) => {
  return request.post<RestoreObjectResultResponse>(`/api/v2/jt808Device/video/restore`, params);
};


///////
/**
 * OssEntity
 */
export type OssEntity = {
  ossBucket?: null | string;
  ossGroup?: null | string;
  ossKey?: null | string;
  ossUrl?: null | string;
  [property: string]: any;
}


/**
 * R«RestoreObjectResult»
 */
export type RestoreObjectResultResponse = {
  code?: number | null;
  count?: number | null;
  data?: RestoreObjectResult;
  ignoreColumns?: string[] | null;
  msg?: null | string;
  success?: boolean | null;
  [property: string]: any;
}

/**
 * RestoreObjectResult
 */
export type RestoreObjectResult = {
  clientCRC?: number | null;
  requestId?: null | string;
  response?: ResponseMessage;
  serverCRC?: number | null;
  statusCode?: number | null;
  versionId?: null | string;
  [property: string]: any;
}

/**
 * ResponseMessage
 */
export type ResponseMessage = {
  content?: { [key: string]: any };
  contentLength?: number | null;
  /**
   * For convenience of logging invalid response
   */
  errorResponseAsString?: null | string;
  headers?: MapString;
  httpResponse?: { [key: string]: any };
  request?: Request;
  statusCode?: number | null;
  uri?: null | string;
  [property: string]: any;
}

/**
 * Map«String»
 */
export type MapString = {
  key?: null | string;
  [property: string]: any;
}

/**
 * Request
 */
export type Request = {
  content?: { [key: string]: any };
  contentLength?: number | null;
  headers?: MapString;
  method?: Method;
  uri?: null | string;
  useChunkEncoding?: boolean | null;
  useUrlSignature?: boolean | null;
  [property: string]: any;
}

export enum Method {
  Delete = "DELETE",
  Get = "GET",
  Head = "HEAD",
  Options = "OPTIONS",
  Post = "POST",
  Put = "PUT",
}